import { z } from 'zod';
/**
 * Represents a single actor in a workflow, which can be a user or a team.
 */
const zWorkflowActorSchema = z.object({
    id: z.string().describe('The UUID of the user or team.'),
    type: z.enum(['user', 'team']).describe('The type of the entity.'),
    name: z.string().describe('The display name of the user or team.'),
    reasoning: z.string().describe('Reasoning for selecting this actor.'),
});
/**
 * The expected structured output from the LLM for the "Approval Check" workflow.
 */
export const zDocumentApprovalResultSchema = z.object({
    summary: z
        .string()
        .describe('A concise summary explaining why approval is or is not required, referencing the specific clauses, without referencing the approvers.'),
    isApprovalRequired: z.boolean().describe('A simple true/false indicating if any approval is required.'),
    approvers: z.array(zWorkflowActorSchema).describe('A list of users or teams who need to approve.'),
});
